import { FC } from 'react';

import { WithStyles, withStyles } from '@core/theme/utils/with-styles';

import { styles } from './SingleFileUploadButton.styles';
import { FileUploadButton, FileUploadButtonProps } from '../FileUploadButton';

export interface SingleFileUploadButtonProps
  extends Omit<FileUploadButtonProps, 'classes' | 'multiple' | 'onFileSelect' | 'onReject'>,
    WithStyles<typeof styles> {
  onFileSelect: (file: File) => void;
  onReject?: (rejectedFile: File) => void;
}

const SingleFileUploadButtonComponent: FC<SingleFileUploadButtonProps> = ({
  classes,
  onFileSelect,
  onReject,
  ...props
}) => {
  return (
    <FileUploadButton
      classes={{ root: classes.root }}
      multiple={false}
      onFileSelect={(file) => {
        onFileSelect(file as File);
      }}
      onReject={(file) => {
        if (onReject) {
          onReject(file as File);
        }
      }}
      {...props}
    />
  );
};

export const SingleFileUploadButton = withStyles(styles)(SingleFileUploadButtonComponent);
